var $ = require('jquery');

function OrtsEditor() {
	var readonly = $("input[name='readonly']");
	if (readonly.val() == 1) {
		$('input, textarea').prop('readonly', true);
		$('select').prop('disabled', true);
	}
}

module.exports = OrtsEditor;
